import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import InstanceView from "@/views/InstanceView.vue";
import InstanceDetailView from "@/views/InstanceDetailView.vue";
import SettingProfileView from "@/views/SettingProfileView.vue";
import PaymentView from "@/views/PaymentView.vue";
import RegistrationView from "@/views/RegistrationView.vue";
import ConfirmationView from "@/views/ConfirmationView.vue";
import LoginView from "@/views/LoginView.vue";
import PaymentSuccessView from "@/views/PaymentSuccessView.vue";
import PaymentFailView from "@/views/PaymentFailView.vue";
import PageNotFoundView from "@/views/PageNotFoundView.vue";

const routes: Array<RouteRecordRaw> = [
	// Список инстансов
	{
		path: "/",
		name: "instances",
		component: InstanceView,
	},
	// Инстанс - подробно
	{
		path: "/instance/detail/:id",
		name: "instance-detail",
		component: InstanceDetailView,
	},
	// Настройки профиля
	{
		path: "/setting/profile",
		name: "setting-profile",
		component: SettingProfileView,
	},
	// Оплата
	{
		path: "/payment",
		name: "payment",
		component: PaymentView,
	},
	// Оплата прошла успешно
	{
		path: "/payment/success/:payType/:orderId/:instanceId/:newExpired",
		name: "payment-success",
		component: PaymentSuccessView,
	},
	// Не удалось провести оплату
	{
		path: "/payment/fail/:payType/:orderId",
		name: "payment-fail",
		component: PaymentFailView,
	},
	// Авторизация
	{
		path: "/login",
		name: "login",
		component: LoginView,
	},
	// Подтверждение
	{
		path: "/confirmation",
		name: "confirmation",
		component: ConfirmationView,
	},
	{
		path: "/error/404",
		name: "page-not-found",
		component: PageNotFoundView,
	},
	{ path: "/:pathMatch(.*)*", component: PageNotFoundView },
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
